/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Container } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios } from "~/tools";

function Docs() {
  const [spec, setSpec] = React.useState<any>(null);
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const fetchDocs = React.useCallback(async () => {
    try {
      const { data } = await Axios().get("/docs");
      setSpec(data);
    } catch (e) {
      showError(e.response);
    }
  }, [Axios]);

  React.useEffect(() => {
    fetchDocs();
  }, [fetchDocs]);

  return (
    <Container css={{ height: "90%" }}>
      <Box css={{ height: "100%" }}>
        <iframe
          id="swaggerFrame"
          title="Swagger UI"
          width="100%"
          height="100%"
          srcDoc={spec}
        />
      </Box>
    </Container>
  );
}

export { Docs };
